import { render, staticRenderFns } from "./ColumnLock.vue?vue&type=template&id=e15899c4&scoped=true"
import script from "./ColumnLock.vue?vue&type=script&lang=ts"
export * from "./ColumnLock.vue?vue&type=script&lang=ts"
import style0 from "./ColumnLock.vue?vue&type=style&index=0&id=e15899c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15899c4",
  null
  
)

export default component.exports